module.exports = __webpack_public_path__ + "img/bosspack_k.513c9bf0.png";